import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setAliasStatus } from '../services/AdministrationService';

// FNP-2137: refetch the admin aliases list so the table shows the new status.
export const useSetAliasStatus = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, aliasStatus }: { id: string, aliasStatus: 'ENABLED' | 'DISABLED' }) =>
            setAliasStatus(id, aliasStatus),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['admin', 'aliases'] })
    });
};
